import {ModelWithParent} from "FormBuilder/Core/Models/ModelWithParenth";
import {FBColumnModel} from "FormBuilder/Core/FBColumn.Model";
import {FBFieldWithPriceBaseModel} from "FormBuilder/Fields/Core/FBFieldWithPriceBase.Model";
import {FBFieldBaseModel} from "FormBuilder/Fields/Core/FBFieldBase.Model";
import {FBDividerOptions} from "./FBDivider.Options";

export class FBDividerModel extends FBFieldBaseModel<FBDividerOptions,FBColumnModel>{
    GetStoresInformation(): boolean {
        return false;
    }

    protected InternalSerialize(obj: object) {
    }

    InitializeStartingValues() {
    }


    GetDynamicFieldNames(): string[] {
        return ['FBDivider'];
    }
}